import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Logo } from "@/components/Primitives";
import { scrollToId } from "@/lib/site";

export const Footer = () => (
  <footer className="bg-[var(--ink)] text-white pt-24 pb-10 overflow-hidden" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <button onClick={() => scrollToId("quote")} data-testid="footer-cta" className="group text-left block">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-slate-300">Ready when you are</p>
        <p className="mt-4 font-display text-5xl sm:text-7xl lg:text-8xl font-semibold tracking-[-0.04em] leading-[0.95]">
          Start saving <span className="font-serif-i text-[var(--mint)]">today</span>
          <ArrowUpRight className="inline-block ml-3 h-12 w-12 sm:h-20 sm:w-20 group-hover:rotate-45 transition-transform duration-500" />
        </p>
      </button>
      <div className="mt-20 pt-8 border-t border-white/15 flex flex-col sm:flex-row gap-6 justify-between sm:items-center text-sm text-slate-300">
        <Logo light />
        <p>Merchant services · POS systems · Online & mobile payments · Payroll</p>
        <div className="flex items-center gap-6">
          <span>© {new Date().getFullYear()} Vectis Payments</span>
          <Link to="/admin" data-testid="footer-admin-link" className="hover:text-white">Admin</Link>
        </div>
      </div>
    </div>
  </footer>
);
